import {
    GIFTLOADING,
    GIFTSUCCESS,
    GIFTERROR,
    GIFTFAILED,
    GIFTRESET,
    USERDATAUPDATE
} from "../actionTypes";

import { ToLocalStorage } from "../../utils/localStorage";
import { server_url } from "../axios";


export const giftsuccess = $=> {
    
    return {
        type: GIFTSUCCESS,
    }
}
export const giftreset = $ => {
    return {
        type: GIFTRESET
    }
}
export const gifterror = (err) => {
    return {
        type: GIFTERROR,
        payload: err
    }
}
export const giftloading = $ => {
    return {
        type: GIFTLOADING
    }
}
export const giftfailed = payload => {
    return {
        type: GIFTFAILED,
        payload: payload
    }
}
export const userdataupdate = payload => {
    return {
        type: USERDATAUPDATE,
        payload: payload
    }
}




 

export const sendGift = payload => async dispatch => {
     dispatch(giftloading())
    try {
    
         await server_url.post('gift/sendgift', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user);
                dispatch(giftsuccess());
                dispatch(userdataupdate(res.data.user));
            })
    } catch (e) {
        dispatch(giftfailed(e.response.data.message))
    };
}


export const findUserGifts = (id, fn) => async dispatch => {
    try {
        await server_url.get(`gift/${id}`)
            .then(res => {
                fn(res.data.gift);     
            })
    } catch (e) {
       console.error(e.response.data.message)
    };
}

